import React, { ReactNode } from 'react';
import { CardKanban } from './card.style';

type Props = {
  onClick: () => void;
  children?: ReactNode;
  status: string;
};

const Card = (props: Props) => {
  return (
    <CardKanban borderStatus={props.status ?? ''} onClick={props.onClick}>
      {props.children}
    </CardKanban>
  );
};

export default Card;
